import React from 'react';
import { ViewCompact } from '@mui/icons-material';

import theme from '@/constants/theme';
import { useSortDrag, useSortDrop } from '@/hooks/useSortDnD';
import { Content } from '@/services/contents/content.vm';

interface Props {
  content: Content;
  index: number;
  moveContent: (fromIndex: number, toIndex: number) => void;
}

const ReorderContentCard: React.FC<Props> = ({ content, index, moveContent }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [, drop] = useSortDrop({
    ref: ref as React.RefObject<HTMLDivElement>,
    index,
    moveItem: moveContent,
    name: 'content',
  });

  const [{ isDragging }, drag] = useSortDrag({
    id: content.id,
    index,
    name: 'content',
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        display: 'flex',
        gap: 16,
        backgroundColor: theme.colors.background.secondary,
        padding: 16,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        color: theme.colors.text.default,
        alignItems: 'center',
        borderRadius: 8,
        cursor: 'move',
        opacity: isDragging ? 0.2 : 1,
      }}
    >
      <ViewCompact style={{ color: theme.colors.text.caption }} />
      <div style={{ display: 'flex', gap: 4, flexDirection: 'column' }}>
        <h3>{content.title}</h3>
      </div>
    </div>
  );
};

export default ReorderContentCard;
